import { useAccountConsultsParams } from './account/useAccountConsults.t';
import { getAppointmentsParams } from './appointment/getAppointments';

export const QueryKeys = {
  appointments: (memberId: string, params: getAppointmentsParams) => ['/appointments', memberId, params],
  accountConsults: (params: useAccountConsultsParams) => ['/patients/patient_consults', params],
  userExperience: () => ['/patients/experience'],
  userExperienceCards: () => ['/patients/experience/cards'],
  tokenState: () => ['/health_system/token_state'],
  patientPendingAgreements: (patientId: string | undefined) => [`/patients/patients/${patientId}/pending_agreements`],
  insuranceCoverage: (patientId: string) => ['/patients/patients', patientId, 'insurance_coverage'],
  updateAppointment: (appointmentId: string) => ['/appointments', appointmentId],
};
